module.exports = __webpack_public_path__ + "static/Asha-Krishnan.5264cccb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Asha-Krishnan.jpg
// module id = 913
// module chunks = 146520050992020